import { Box, Typography, Button, Container, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFoundPage = () => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Box textAlign="center">
        <Typography variant="h3" color="error" gutterBottom>
          {t("notFound.title")}
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          {t("notFound.description")}
        </Typography>
        <Stack direction="row" justifyContent="center">
          <Button variant="contained" color="primary" onClick={() => navigate("/")}>
            {t("notFound.backHome")}
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default NotFoundPage;
